import { Routes } from '@angular/router';
import { canActivateRoute } from './auth';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    loadComponent: async () => import('@app/layout').then((m: any) => m.DefaultLayoutComponent),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: async () => import('@app/pages/dashboard/dashboard.component').then((m) => m.DashboardComponent),
        canActivate: [canActivateRoute],
      },
      {
        path: 'accounts',
        loadComponent: async () => import('@app/pages/accounts/accounts.component').then((m) => m.AccountsComponent),
        canActivate: [canActivateRoute],
      },
      {
        path: 'connections',
        loadComponent: async () => import('@app/pages/connections/connections.component').then((m) => m.ConnectionsComponent),
        canActivate: [canActivateRoute],
      },
      {
        path: 'updates',
        loadComponent: async () => import('@app/pages/updates/updates.component').then((m) => m.UpdatesComponent),
        canActivate: [canActivateRoute],
      },
      {
        path: 'invoices',
        loadComponent: async () => import('@app/pages/invoices/invoices.component').then((m) => m.InvoicesComponent),
        canActivate: [canActivateRoute],
      },
      {
        path: 'backups',
        loadComponent: async () => import('@app/pages/backups/backups.component').then((m) => m.BackupsComponent),
        canActivate: [canActivateRoute],
      },
      {
        path: 'certificates',
        loadComponent: async () => import('@app/pages/certificates/certificates.component').then((m) => m.CertificatesComponent),
        canActivate: [canActivateRoute],
      },
      {
        path: 'sync',
        loadComponent: async () => import('@app/pages/sync/sync.component').then((m) => m.SyncComponent),
        canActivate: [canActivateRoute],
      },
      {
        path: 'broadcast',
        loadComponent: async () => import('@app/pages/broadcasts/broadcasts.component').then((m) => m.BroadcastsComponent),
        canActivate: [canActivateRoute],
      },
      {
        path: 'offline',
        loadComponent: async () => import('@app/pages/offline/offline.component').then((m) => m.OfflineComponent),
        canActivate: [canActivateRoute],
      },
      {
        path: 'settings',
        loadComponent: async () => import('@app/pages/settings/settings.component').then((m) => m.SettingsComponent),
        canActivate: [canActivateRoute],
      },
      {
        path: 'perfil',
        loadComponent: async () => import('@app/pages/perfil').then((m) => m.PerfilComponent),
        canActivate: [canActivateRoute],
      },
    ],
  },
  {
    path: 'signin',
    loadComponent: async () => import('@app/auth').then((m: any) => m.SigninComponent),
  },
  {
    path: 'signup',
    loadComponent: async () => import('@app/auth').then((m: any) => m.SignupComponent),
  },
  {
    path: 'forgot',
    loadComponent: async () => import('@app/auth').then((m: any) => m.ForgotComponent),
  },
  {
    path: 'magic-link',
    loadComponent: async () => import('@app/auth').then((m: any) => m.MagicLinkComponent),
  },
  {
    path: 'otp',
    loadComponent: async () => import('@app/auth').then((m: any) => m.OtpComponent),
  },
  {
    path: 'whatsapp',
    loadComponent: async () => import('@app/auth').then((m: any) => m.WhatsappLoginComponent),
  },
  {
    path: 'reset',
    loadComponent: async () => import('@app/auth').then((m: any) => m.ResetComponent),
  },
  {
    path: 'confirm',
    loadComponent: async () => import('@app/auth').then((m: any) => m.ConfirmComponent),
  },
  {
    path: 'termos',
    loadComponent: async () => import('@app/legal').then((m: any) => m.LegalPageComponent),
    data: { document: 'terms' },
  },
  {
    path: 'privacidade',
    loadComponent: async () => import('@app/legal').then((m: any) => m.LegalPageComponent),
    data: { document: 'privacy' },
  },
  {
    path: 'error',
    loadComponent: async () => import('@app/error').then((m: any) => m.ErrorComponent),
  },
  {
    path: '**',
    redirectTo: 'error',
    pathMatch: 'full',
  },
];
